export const smoothScrollingToElement = domElementId => {
  const element = document.getElementById(domElementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};
